import React from 'react'
import './Login.css'
import Spinner from '../Components/Spinner'
import { LoadingProps } from '../Components/LoginWrapper'

const LoginPage: React.FC<LoadingProps> = ({ onLogin, isLoading, errorMsg }) => (
  <div className="LoadingPage">
    <div className='image-holder'>
      <div className='mask-image'>
      <div className="content">
        <h4>Login to access this page</h4>
        {errorMsg && <h4 className="error-msg">{errorMsg}</h4>}
        <button id="login" onClick={onLogin} className={`btn ${isLoading ? 'btn-loading' : ''}`}>
          {isLoading ? <Spinner /> : 'Login'}
        </button>
      </div>
      </div>
    </div>
  </div>
)

export default LoginPage
